import type { ComponentPropsWithRef } from 'react';

import { statusColorThemes } from '~/styles/themes.css';
import { clsx } from '~/styles/utils';

import { Icon, type IconName } from '../Icon/Icon';
import { tagStyle } from './StatusTag.css';

type Props = ComponentPropsWithRef<'div'> & {
  icon: IconName;
  label: string;
  status: keyof typeof statusColorThemes;
};

export const StatusTag = ({ icon, label, status, ...delegated }: Props) => {
  return (
    <div {...delegated} className={clsx(tagStyle, statusColorThemes[status], delegated.className)}>
      <Icon name={icon} size={20} />

      <p>{label}</p>
    </div>
  );
};
